import { GenderInput, type GenderInputProps } from '../../inputs/GenderInput';
import { useEditorContext } from '../EditorContext';
import { setEditorFieldValue, type LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalGenderItemProps<TFormType> extends Omit<GenderInputProps, 'value' | 'onChange'> {
    fieldKey: LooseKeys<TFormType>;
    required?: boolean;
    label?: string;
    labelWidth?: number;
}

export const ModalGenderItem = <TFormType,>({
    label,
    labelWidth,
    fieldKey,
    required,
    ...genderInputProps
}: ModalGenderItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const error = form.errors[fieldKey];

    const handleChange = (value: string | null) => {
        setEditorFieldValue(form, fieldKey, value);
    };

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <GenderInput
                key={form.key(fieldKey)}
                {...form.getInputProps(fieldKey)}
                readOnly={loading}
                {...genderInputProps}
                onChange={handleChange}
            />
        </ModalEditorItemBase>
    );
};
